import React from 'react';
import { Box, Flex, Text, xcss } from '@atlaskit/primitives';
import { Maybe } from '@css-xp/graphtypes/src/generated-types-new';
import AchIcon from '../../assets/img/ach-payment-icon.svg';

export type AchPanelProps = {
  bankName?: Maybe<string> | undefined;
  last4?: Maybe<string> | undefined;
  showBorder?: boolean;
  showInfoInline?: boolean;
  iconHeight?: number;
  iconWidth?: number;
  bankFontSize?: 'large' | 'medium' | 'small';
  last4FontSize?: 'large' | 'medium' | 'small';
  hideIcon?: boolean;
  width?: string;
};

const containerStyle = (showBorder: boolean, width: string) =>
  xcss({
    borderStyle: showBorder ? 'solid' : 'none',
    borderWidth: showBorder ? 'border.width' : 'border.width.0',
    borderColor: showBorder ? 'color.border' : 'color.border.inverse',
    padding: showBorder ? 'space.200' : 'space.0',
    width,
    borderRadius: 'border.radius.100',
  });

const infoInlineStyle = xcss({
  borderLeftStyle: 'solid',
  borderLeftWidth: 'border.width',
  borderLeftColor: 'color.border',
  paddingLeft: 'space.100',
  paddingRight: 'space.100',
});

export const AchPanel = ({
  bankName,
  last4,
  showBorder = false,
  showInfoInline = true,
  iconHeight = 30,
  iconWidth = 30,
  bankFontSize = 'small',
  last4FontSize = 'medium',
  hideIcon = false,
  width = '100%',
}: AchPanelProps) => {
  return (
    <Box testId="ach-panel" xcss={containerStyle(showBorder, width)} id="ach-panel">
      <Flex gap={showInfoInline ? 'space.100' : 'space.200'} alignItems="center">
        {!hideIcon && (
          // @ts-ignore
          <img src={AchIcon} alt="AchIcon" height={iconHeight} width={iconWidth} id="ach-panel-icon" />
        )}
        <Flex
          gap={showInfoInline ? 'space.100' : 'space.025'}
          alignItems={showInfoInline ? 'center' : 'start'}
          direction={showInfoInline ? 'row' : 'column'}
        >
          <Text weight="semibold" size={last4FontSize}>
            •• •••• {last4}
          </Text>
          <Box xcss={showInfoInline ? infoInlineStyle : undefined}>
            <Text size={bankFontSize}>{bankName}</Text>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
